import styled from "styled-components";

export const Aside = styled.aside`
	display: none;
	background-color: #dddddd;
	overflow: hidden;
	margin: 20px 37px;
	height: 90px;

	@media (min-width: 900px) {
		margin: 0;
		min-width: 300px;
		height: 250px;
	}
`;
